import memoizeOne from 'memoize-one';
import { COMMENT_SUMMARY_TYPE, REMOTE_ISSUE_LINKS_TYPE } from '@atlassian/jira-business-constants';
import { getSupportedFieldTypes } from '@atlassian/jira-business-fields/supported-types';
import {
	DATE_CF_TYPE,
	DATETIME_CF_TYPE,
	DUE_DATE_TYPE,
	COMPONENTS_TYPE,
	COMMENT_TYPE,
	CREATED,
	UPDATED,
	ASSIGNEE_TYPE,
	REPORTER_TYPE,
	USER_CF_TYPE,
	URL_CF_TYPE,
	PRIORITY_TYPE,
	SPRINT_TYPE,
	SUMMARY_TYPE,
	SELECT_CF_TYPE,
	STATUS_TYPE,
	TEXT_CF_TYPE,
	LABELS_TYPE,
	LABELS_CF_TYPE,
	ISSUE_TYPE,
	NUMBER_CF_TYPE,
	MULTI_SELECT_CF_TYPE,
	MULTI_USER_CF_TYPE,
	PEOPLE_CF_TYPE,
	STORY_POINTS_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
	TIME_ESTIMATE_TYPE,
	TEXT_AREA_CF_TYPE,
	MULTI_CHECKBOXES_CF_TYPE,
	CATEGORY_TYPE,
} from '@atlassian/jira-platform-field-config';
import { UP, DOWN, LEFT, RIGHT } from '../../../common/constants';
import type { Direction } from '../../../controllers/cell-navigation/types';

export const KEY_LEFT = 'ArrowLeft';
export const KEY_RIGHT = 'ArrowRight';
export const KEY_UP = 'ArrowUp';
export const KEY_DOWN = 'ArrowDown';
export const KEY_SPACE = ' ';
export const KEY_ENTER = 'Enter';
export const KEY_ESCAPE = 'Escape';
export const KEY_TAB = 'Tab';

export const VALID_HORIZONTAL_NAV_KEYS = new Set([KEY_LEFT, KEY_RIGHT, KEY_TAB]);
export const VALID_NAVIGATION_KEYS = new Set([
	...VALID_HORIZONTAL_NAV_KEYS,
	KEY_UP,
	KEY_DOWN,
	KEY_SPACE,
	KEY_ENTER,
	KEY_ESCAPE,
]);

export const NAV_KEYS_TO_DIRECTION: Record<string, Direction> = {
	[KEY_LEFT]: LEFT,
	[KEY_RIGHT]: RIGHT,
	[KEY_UP]: UP,
	[KEY_DOWN]: DOWN,
};

// todo: delete this on cleaning up jira_list_keyboard_nav
const NEW_NAV_SUPPORTED_FIELD_TYPES = new Set([
	ASSIGNEE_TYPE,
	CATEGORY_TYPE,
	COMPONENTS_TYPE,
	COMMENT_TYPE,
	COMMENT_SUMMARY_TYPE,
	CREATED,
	DATE_CF_TYPE,
	DATETIME_CF_TYPE,
	DUE_DATE_TYPE,
	ISSUE_TYPE,
	LABELS_TYPE,
	LABELS_CF_TYPE,
	MULTI_CHECKBOXES_CF_TYPE,
	MULTI_SELECT_CF_TYPE,
	MULTI_USER_CF_TYPE,
	NUMBER_CF_TYPE,
	PEOPLE_CF_TYPE,
	PRIORITY_TYPE,
	REMOTE_ISSUE_LINKS_TYPE,
	REPORTER_TYPE,
	STORY_POINTS_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
	SPRINT_TYPE,
	SUMMARY_TYPE,
	SELECT_CF_TYPE,
	STATUS_TYPE,
	TEXT_AREA_CF_TYPE,
	TEXT_CF_TYPE,
	TIME_ESTIMATE_TYPE,
	UPDATED,
	URL_CF_TYPE,
	USER_CF_TYPE,
	'key',
]);
export const getNewNavSupportedFieldTypes = memoizeOne(
	(): Set<string> => new Set([...NEW_NAV_SUPPORTED_FIELD_TYPES, ...getSupportedFieldTypes(true)]),
);
